import SideBar from "./sideBar"
import DashboardHeader from "./DashboardHeader"
import Footer from "./Footer"

export default {
    SideBar,
    DashboardHeader,
    Footer
};